export enum ObjectType {
  CAMPAIGN = 'CAMPAIGN',
  COMMENT = 'COMMENT',
  ITEM = 'ITEM',
  USER = 'USER',
}

export enum ActionType {
  IGNORE = 'IGNORE',
  DELETE = 'DELETE',
  HIDE = 'HIDE',
  REMOVE = 'REMOVE',
  COMMENT = 'COMMENT',
}

const buildButtonNameMap = () => {
  return new Map([
    [ActionType.IGNORE, 'unsafe-content.popover.button.ignore-btn'],
    [ActionType.DELETE, 'unsafe-content.popover.button.delete-btn'],
    [ActionType.HIDE, 'unsafe-content.popover.button.hide-btn'],
    [ActionType.REMOVE, 'unsafe-content.popover.button.remove-btn'],
    [ActionType.COMMENT, 'unsafe-content.popover.button.comment-btn'],
  ]);
};

const buildWarningMessageMap = () => {
  return new Map([
    [ActionType.IGNORE, 'unsafe-content.popover.ignore-label'],
    [ActionType.DELETE, 'unsafe-content.popover.delete-label'],
    [ActionType.HIDE, 'unsafe-content.popover.hide-label'],
    [ActionType.REMOVE, 'unsafe-content.popover.remove-label'],
    [ActionType.COMMENT, 'unsafe-content.popover.add-comment-label'],
  ]);
};

export const buttonNameMap = buildButtonNameMap();
export const warningMessageMap = buildWarningMessageMap();
